import { Entity, Field } from 'typegraph';

import LaunchURL from 'common/entities/LaunchURL';
import Product from "./Product";

@Entity({one: "entry", many: "entries"})
export default class Entry {

	@Field()
	public id: string;

	@Field()
	public startDate: string;

	@Field()
	public endDate: string;

	@Field({entity: LaunchURL})
	public launchURL: LaunchURL;

	@Field()
	public displayName: string;

	@Field({entity: Product})
	public product: Product;

}



// WEBPACK FOOTER //
// ./src/panels/featuredItems/entities/Entry.ts